import { render, staticRenderFns } from "./AssetLinkedFileAddForm.vue?vue&type=template&id=2092f890&scoped=true"
import script from "./AssetLinkedFileAddForm.vue?vue&type=script&lang=js"
export * from "./AssetLinkedFileAddForm.vue?vue&type=script&lang=js"
import style0 from "./AssetLinkedFileAddForm.vue?vue&type=style&index=0&id=2092f890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092f890",
  null
  
)

export default component.exports